export default __webpack_public_path__ + "static/banumukhtaroffice-510bdc9a4e352c49ebb0f127610f9b52.png";